import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-button");
/**
 * Creates a button theme based on the button theming props. This is really just
 * used so that other elements like clickable `<div>`s or `<input type="file">`
 * can look like buttons.
 *
 * @param props - An object containing the themeable button props to generate a
 * button theme className.
 * @returns a string of class names to create an element with a button theme.
 */
export function buttonThemeClassNames(_a) {
    var _b;
    var _c = _a.theme, propTheme = _c === void 0 ? "clear" : _c, _d = _a.themeType, themeType = _d === void 0 ? "flat" : _d, _e = _a.buttonType, buttonType = _e === void 0 ? "text" : _e, _f = _a.disabled, propDisabled = _f === void 0 ? false : _f, className = _a.className;
    var theme = propTheme === "disabled" ? "clear" : propTheme;
    var disabled = propDisabled || propTheme === "disabled";
    var text = buttonType === "text";
    var icon = buttonType === "icon";
    var outline = themeType === "outline";
    var contained = themeType === "contained";
    var clear = theme === "clear";
    return cn(block((_b = {
            text: text,
            icon: icon,
            disabled: disabled,
            contained: !disabled && contained,
            outline: outline
        },
        _b[theme] = !disabled && !clear && contained,
        _b["text-" + theme] = !disabled && !clear && !contained,
        _b["outline-" + theme] = !disabled && !clear && outline,
        _b)), className);
}
//# sourceMappingURL=buttonThemeClassNames.js.map